import { clsx, type ClassValue } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

// Extend tailwind-merge to fix prefix issue (e.g. 'text-button' will cause 'text-neutral-white' to be ignored)
const twMerge = extendTailwindMerge({
  prefix: 'tw-', // This tells tailwind-merge that all utility classes will start with tw-.
});

export function mergeClasses(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
